import { CommandBarButton, IButtonProps, IconButton } from "@fluentui/react";
import React from "react";

import { TooltipHost } from "../../surfaces/tooltip/TooltipHost";

export type AddButtonProps = Pick<IButtonProps, "id" | "disabled" | "onClick" | "styles"> & {
    isLabeled?: boolean;
    label?: string;
};

export const AddButton: React.FunctionComponent<AddButtonProps> = (props: AddButtonProps) => {
    const label = props.label || "Add";

    return (
        <>
            {props.isLabeled ? (
                <CommandBarButton
                    key={props.id}
                    iconProps={{ iconName: "Add" }}
                    disabled={props.disabled}
                    onClick={props.onClick}
                    allowDisabledFocus={false}
                    checked={false}
                    ariaLabel={label}
                    text={label}
                    styles={props.styles}
                />
            ) : (
                <TooltipHost content={label} styles={{ root: { display: "inline-block" } }}>
                    <IconButton
                        key={props.id}
                        iconProps={{ iconName: "Add" }}
                        disabled={props.disabled}
                        onClick={props.onClick}
                        allowDisabledFocus={false}
                        checked={false}
                        ariaLabel={label}
                        styles={props.styles}
                    />
                </TooltipHost>
            )}
        </>
    );
};
